import React from 'react';
import PropTypes from 'prop-types';

import { getMessage } from 'util/locale';
import { Dropdown } from '@tcc/crate';

import { isSeasonVariableCountry } from 'constants/countryCodes';
import { AGRONOMIC_SEASONS_BY_COUNTRY } from 'constants/advanced';

const Season = ({ 
  isReviewScriptStep,
  onSelectSeason,
  selectedSeasonId,
  fieldCountry
}) => {
  const seasons = AGRONOMIC_SEASONS_BY_COUNTRY[fieldCountry];
  const options = seasons?.map((season) => ({
    value: getMessage(`season__${season}`),
    id: season 
  }));

  const selectedSeason = selectedSeasonId && options?.find(({ id }) => id === selectedSeasonId);

  return isSeasonVariableCountry(fieldCountry) && !isReviewScriptStep
    ? (
      <section className='vra-planting-plan-form__season-wrapper'>
        <Dropdown 
          options={options}
          label={getMessage('season-variable')}
          placeholder={getMessage('placeholder-text__select-season')}
          testId='season-select'
          setValue={onSelectSeason}
          value={selectedSeason?.value}
        />
      </section>
    ) : null;
};

Season.propTypes = {
  isReviewScriptStep: PropTypes.bool.isRequired,
  onSelectSeason: PropTypes.func.isRequired,
  selectedSeasonId: PropTypes.string,
  fieldCountry: PropTypes.string.isRequired
};

export default Season;
